import React, { useEffect, useRef, useState } from "react";
import { DropDown, InputField, SearchInput, SubmitButton, TextComponent } from "../../../../components";
import styles from "./CreateChatRoom.module.css";
import { Col, Row, List } from "antd";
import { BsCheckCircleFill, BsCircle } from "react-icons/bs";
import RoomImage from "../../../../assets/RoomImage.png";
import { AiFillPlusCircle } from "react-icons/ai";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { ChatMiddleware } from "../../../../Store/Middlewares/ChatMiddleware";
import { useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";

const CreateChatRoom = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const role = Storage.getERole("@role");
  const ref = useRef()

  const [chatRoomName, setchatRoomName] = useState("");
  const [topic, setTopic] = useState("");
  const [memberList, setMemberList] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState([]);
  const [hashtags, setHashtags] = useState([]);
  const [userEvents, setuserEvents] = useState([])
  const [selectedEvent, setselectedEvent] = useState(null)
  const [eventImage, setEventImage] = useState(null)
  const [search, setSearch] = useState('');
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onPressAddMember = (item, index) => {
    if (!selectedMemberList) {
      setSelectedMemberList(item);
    }
    else if (selectedMemberList && !selectedMemberList.includes(item)) {
      setSelectedMemberList([...selectedMemberList, item]);
    } else {
      selectedMemberList.splice(selectedMemberList.indexOf(item), 1);
      setSelectedMemberList([...selectedMemberList])
    }
  };

  const onPressAddTopics = (e) => {
    e.preventDefault();
    if (!topic) {
      alert('Please enter topic')
    } else {
      let data = [...hashtags]
      if (topic.includes('#')) {
        data.push(topic)
      } else {
        data.push("#" + topic)
      }
      setHashtags(data)
      setTopic('')
    }
  }

  useEffect(() => {

    if (role == roles.vendor) {
      getVendorsList()
    } else {
      dispatch(EventMiddleware.getUserEvents()).then((data) => { setuserEvents(data) }).catch()
    }
  }, [])

  useEffect(() => {
    if (role != roles.vendor) {
      getMemberList()
    }
  }, [selectedEvent])

  const onSelectEvent = (data) => {
    setselectedEvent(data);
  };


  const getMemberList = () => {
    if (selectedEvent != null) {
      dispatch(EventMiddleware.getEventGuest({ event_id: selectedEvent?.id, search: '' })).then((data) => { setMemberList(data) }).catch()
    }
  };
  const getVendorsList = () => {
    dispatch(
      EventMiddleware.getAllVendor({
        role: 'vendor',
        search: search,
        loading: true,
      }),
    )
      .then(data => {
        setMemberList(data);
      })
      .catch();
  };

  const onSearchValue = (val) => {
    setSearch(val)
    clearTimeout(ref.current)
    ref.current = setTimeout(() => {
      dispatch(
        EventMiddleware.getAllVendor({
          role: 'vendor',
          search: val,
          loading: true,
        }),
      )
        .then(data => {
          setMemberList(data);
        })
        .catch();

    }, 1000);
  }

  const CreateGroup = () => {
    if (!chatRoomName || hashtags.length == 0 || selectedEvent == null || selectedMemberList.length == 0 || !eventImage) {
      dispatch(showAlert({ title: 'GroupChat', message: 'All fields are mandatory!', status: 400 }))
    } else {
      dispatch(ChatMiddleware.createChatRoom({ name: chatRoomName, event_id: selectedEvent.id, image: eventImage, members: selectedMemberList, topics: hashtags }))
        .then(() => navigation(-1))
        .catch()
    }
  }

  const CreateVendorsGroup = () => {
    if (
      !chatRoomName ||
      hashtags.length == 0 ||
      selectedMemberList.length == 0 ||
      !eventImage
    ) {
      dispatch(
        showAlert({
          title: 'GroupChat',
          message: 'All fields are mandatory!',
          status: 400,
        }),
      );
    } else {
      dispatch(
        ChatMiddleware.createChatRoom({
          name: chatRoomName,
          image: eventImage,
          members: selectedMemberList,
          topics: hashtags,
        }),
      )
        .then(() => navigation(-1))
        .catch();
    }
  };

  return (
    <div className={styles.mainCon}>
      <TextComponent text={"Chat Room Name"} textClass={styles.subHeading} />
      <div className={styles.inputStyle}>
        <InputField
          placeholder={"Name"}
          value={chatRoomName}
          onChange={(e) => setchatRoomName(e.target.value)}
        />
      </div>

      <Row className={styles.addMemberView}>
        <Col className={styles.colMember}>
          <div className={styles.topicDiv}>
            <TextComponent
              text={"Discuss about the Topic"}
              textClass={styles.subHeading}
            />
            <div className={styles.topicInputDiv}>
              <div className={styles.topicInput}>
                <input placeholder={"#topic"} value={topic} onChange={(e) => setTopic(e.target.value)}></input>
              </div>
              <div className={styles.plusIconDiv}>
                <AiFillPlusCircle onClick={onPressAddTopics} />
              </div>
            </div>
            <List
              dataSource={hashtags}
              className={styles.hashtagsList}
              grid={{}}
              itemLayout="horizontal"
              renderItem={(item, index) => (
                <Row key={index} className={styles.hashtagsItem}>
                  {/* <TextComponent text={"#"} /> */}
                  <TextComponent text={item} />
                </Row>
              )}
            />
          </div>

          {role != roles.vendor &&
            <DropDown
              placeholder={selectedEvent ? selectedEvent?.val : "Select Event"}
              name={"event"}
              label={"Event"}
              onChange={onSelectEvent}
              object={userEvents}
            />
          }

          <TextComponent text={role != roles.vendor ? "Add member" : "Add vendors"} textClass={styles.subHeading} />
          <div className={styles.search}>
            <SearchInput value={search} onChange={(e) => onSearchValue(e.target.value)} placeholder={"Search"} />
          </div>
          <div className={styles.listDiv}>
            <List
              dataSource={memberList}
              className={styles.list}
              renderItem={(item, index) => {

                let selected = selectedMemberList.includes(item)
                return (
                  <Row
                    onClick={() => onPressAddMember(item, index)}
                    key={index}
                    className={styles.itemStyle}
                  >
                    {selected ? (
                      <BsCheckCircleFill className={styles.iconStyle} />
                    ) : (
                      <BsCircle className={styles.iconStyle} />
                    )}
                    <TextComponent
                      text={item?.name}
                      textClass={
                        selected ? styles.itemTextTrue : styles.itemTextFalse
                      }
                    />
                  </Row>
                )
              }}
            />
          </div>
          <div className={styles.btn}>
            <SubmitButton
              title={"Create Chat Room"}
              btnClass={styles.btnStyle}
              onClick={role != roles.vendor ? CreateGroup : CreateVendorsGroup}
            />
          </div>
        </Col>

        <Col className={styles.colImage}>
          <div onClick={handleClick}>
            {/* <img src={RoomImage} /> */}
            <img src={eventImage ? URL.createObjectURL(eventImage) : RoomImage} />
          </div>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => setEventImage(e.target.files[0])}
            ref={hiddenFileInput}
            style={{ display: "none" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default CreateChatRoom;
